module.exports = __webpack_public_path__ + "images/payrollpanda-logo-sm.png";


//////////////////
// WEBPACK FOOTER
// ./images/payrollpanda-logo-sm.png
// module id = 1124
// module chunks = 1